import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { LocationSelectorContext } from './LocationSelectorContext.js';
import { LocationSelectorNode } from './LocationSelectorNode.js';
import { rootToLocationSelectorNodeData, folderToLocationSelectorNodeData } from './utils.js';
import { isResourceDetailFolder } from '../../utils/resourceDetailGuards.js';
import { useQueryResourceRootSpaceSystemList, sortByLastResourceAdded } from '../../../spaces/queries/useQueryResourceRootSpaceSystemList.js';
import { styled } from 'styled-components';
import { ImgEmptySearch } from '@fabric-app/icons/old';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { Flex } from '@fabric-app/ui/components/Flex';
import { P } from '@fabric-app/ui/components/Typography';
import { IntersectionObserverAnchor } from '@fabric-app/ui/components/IntersectionObserver/IntersectionObserver';

const Wrapper = styled.div.withConfig({
  displayName: "LocationSelector__Wrapper",
  componentId: "sc-618cc379-0"
})([
  `border-radius:1rem;background:`,
  `;overflow:hidden;width:100%;min-height:100%;& > *:first-child{border-top:none;}`
], cssVar["color-bg-secondary-button"]);
const SectionsWrapper = styled(Flex).attrs({
  gap: "elementsContainer",
  direction: "column"
}).withConfig({
  displayName: "LocationSelector__SectionsWrapper",
  componentId: "sc-618cc379-1"
})([
  ``
]);
const defaultSpacesMapped = [];
const LocationSelector = ({ searchKeyword = "", querySearchResources, ...contextValue }) => {
  const { spaceRoots } = useQueryResourceRootSpaceSystemList(void 0, {
    includeInbox: true,
    includeWriteableMirrorRoots: true,
    sortFn: sortByLastResourceAdded
  });
  const spacesMapped = spaceRoots?.map(rootToLocationSelectorNodeData) || defaultSpacesMapped;
  const searchResultSpaces = spacesMapped.filter((item) => item.title.toLowerCase().includes(searchKeyword.toLowerCase()));
  const { resources, hasNextPage, fetchNextPage } = querySearchResources;
  const searchResultFolders = resources.filter(isResourceDetailFolder).map(folderToLocationSelectorNodeData);
  const allSearchResults = [
    ...searchResultSpaces,
    ...searchResultFolders
  ];
  return /* @__PURE__ */ jsx(LocationSelectorContext.Provider, {
    value: contextValue,
    children: /* @__PURE__ */ jsx(SectionsWrapper, {
      children: searchKeyword ? /* @__PURE__ */ jsx(Fragment, {
        children: allSearchResults.length === 0 ? /* @__PURE__ */ jsxs(Flex, {
          direction: "column",
          alignItems: "center",
          gap: "sections",
          style: {
            padding: "2rem"
          },
          children: [
            /* @__PURE__ */ jsx("img", {
              src: ImgEmptySearch,
              height: 120,
              width: 120,
              alt: "No results found"
            }),
            /* @__PURE__ */ jsx(P, {
              weight: 500,
              children: "No space or folder found"
            })
          ]
        }) : allSearchResults.map((node) => /* @__PURE__ */ jsx(Wrapper, {
          children: /* @__PURE__ */ jsx(LocationSelectorNode, {
            data: node,
            level: 0,
            prevNodePath: []
          }, node.id)
        }, node.id))
      }) : /* @__PURE__ */ jsxs(Wrapper, {
        children: [
          spacesMapped.map((node) => /* @__PURE__ */ jsx(LocationSelectorNode, {
            data: node,
            level: 0,
            prevNodePath: []
          }, node.id)),
          hasNextPage && /* @__PURE__ */ jsx(IntersectionObserverAnchor, {
            onIntersect: fetchNextPage
          })
        ]
      })
    })
  });
};

export { LocationSelector };
//# sourceMappingURL=LocationSelector.js.map
